import { createFileRoute } from "@tanstack/react-router";
import { requerirEdicionDeSolicitud } from "@/features/solicitudes/utils/guard-edicion";
import { SeleccionarOrdenDeCompraPage } from "@/features/seleccionar-orden-compra/components/SeleccionarOrdenDeCompraPage";
import { solicitudQueryOptions } from "@/features/solicitudes/hooks/use-solicitud";
import { ErrorAlert, WizardPasoSkeleton } from "@/components/ui";

/**
 * Ruta `/solicitudes/$id/orden-compra` · paso previo al CFDI del tipo Orden de
 * Compra. Loader precarga la solicitud.
 */
export const Route = createFileRoute("/_authed-tw/solicitudes/$id/orden-compra")({
  beforeLoad: requerirEdicionDeSolicitud,
  loader: ({ context: { queryClient }, params: { id } }) => queryClient.ensureQueryData(solicitudQueryOptions(id)),
  component: SeleccionarOrdenDeCompraPage,
  pendingComponent: WizardPasoSkeleton,
  errorComponent: ({ error }) => <ErrorAlert error={error} />,
});
